import axios from "../axios";

const updateWithdrawAccount = async function (accessToken, id, params = {}) {
    try {
        const response = await axios.post('withdraw-account/updateWithdrawAccount', params,{
            headers: {
                'Authorization': accessToken
            },
            params: {
                id
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default updateWithdrawAccount;
